import { Resource } from 'model/Resource';
import { HeadlinesDepartmentsListResultModel } from 'api/dto/new/Headlines/HeadlinesDepartment.dto';

export const STORE_NAME = 'headlines';

export namespace HeadlinesState {
  export type Domain = {
    departments: Resource<HeadlinesDepartmentsListResultModel | null>;
    // Persisted so the slide index survives HeaderSidebar's `lg`-breakpoint
    // subtree swap.
    currentSlide: number;
  };

  export const INITIAL_DOMAIN: HeadlinesState.Domain = {
    departments: Resource.createPendingResource<HeadlinesDepartmentsListResultModel | null>(),
    currentSlide: 0,
  };
}
